import { onBeforeUnmount, ref } from 'vue';

import { BREAKPOINTS } from '#/composables/useBreakpoint';

/**
 * 모바일 GNB(햄버거) 열림 상태.
 * - shell.js 의 `#appheader.nav-open` 토글을 컴포넌트 ref 상태로 이관.
 * - lg(980px) 이상으로 넓어지면 자동으로 닫는다(데스크톱 GNB 전환 시 잔여 패널 방지).
 */
export function useMobileNav() {
  const isOpen = ref(false);

  function open() {
    isOpen.value = true;
  }
  function close() {
    isOpen.value = false;
  }
  function toggle() {
    isOpen.value = !isOpen.value;
  }

  // 데스크톱 폭으로 넘어가면 모바일 메뉴를 닫는다.
  let mql: MediaQueryList | null = null;
  if (typeof window !== 'undefined' && 'matchMedia' in window) {
    mql = window.matchMedia(`(min-width: ${BREAKPOINTS.lg}px)`);
    const onChange = (e: MediaQueryListEvent) => {
      if (e.matches) isOpen.value = false;
    };
    mql.addEventListener('change', onChange);
    onBeforeUnmount(() => mql?.removeEventListener('change', onChange));
  }

  return { isOpen, open, close, toggle };
}
